enum Locale {
  EnglishUS = 'en-US',
  SpanishUS = 'es-US',
  PortugueseBR = 'pt-BR',
}

type TypeDateOfBirth = {
  day: number;
  month: number;
  year: number;
};

/**
 * Format the date of birth according to US or BR format
 * @category Formatters
 * @category Date-Time
 */
export function formatDateOfBirth(
  dateOfBirth?: TypeDateOfBirth,
  locale?: Locale,
) {
  if (dateOfBirth) {
    const year = dateOfBirth.year || '';
    const day = dateOfBirth.day || '';
    const month = dateOfBirth.month || '';

    switch (locale) {
      case Locale.PortugueseBR:
        return `${day}/${month}/${year}`;
      default:
        return `${month}/${day}/${year}`;
    }
  }
}
